export const getFigmaFileId = (link: any) => (link ? link.split('/')[4] : '');
